import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QuickLink } from './bricks';
import { ReactComponent as ComprasOnlineSvg } from '../assets/images/footer/eroski-compra-online.svg';
import { ReactComponent as TiendasSvg } from '../assets/images/footer/eroski-tiendas.svg';
import { ReactComponent as ValesSvg } from '../assets/images/footer/eroski-vales-ahorro.svg';
import { ReactComponent as ContactoSvg } from '../assets/images/footer/eroski-contacto.svg';
import { ReactComponent as FolletosSvg } from '../assets/images/footer/eroski-folletos.svg';
import { ReactComponent as ClubSvg } from '../assets/images/footer/eroski-club.svg';
import { ReactComponent as LogoSvg } from '../assets/images/footer/eroski-logo-invertido.svg';
import { ReactComponent as Face } from '../assets/images/footer/eroski-footer3-facebook.svg';
import { ReactComponent as Twitter } from '../assets/images/footer/eroski-footer3-twitter.svg';
import { ReactComponent as Insta } from '../assets/images/footer/eroski-footer3-instagram.svg';
import { ReactComponent as Pinterest } from '../assets/images/footer/eroski-footer3-pinterest.svg';
import { ReactComponent as Tiktok } from '../assets/images/footer/eroski-footer3-tiktok.svg';
import { ReactComponent as Linkedin } from '../assets/images/footer/eroski-footer3-linkedin.svg';
import { ReactComponent as Youtube } from '../assets/images/footer/eroski-footer3-youtube.svg';
import { ReactComponent as Payment } from '../assets/images/footer/eroski-formas-de-pago.svg';
import { ReactComponent as Trust } from '../assets/images/footer/eroski-confianza-online.svg';
import { ReactComponent as Digital } from '../assets/images/footer/eroski-adigital.svg';
import { ReactComponent as Android2 } from '../assets/images/footer/eroski-footer2-android.svg';
import { ReactComponent as Ios2 } from '../assets/images/footer/eroski-footer2-ios.svg';
import eroskisello03 from '../assets/images/footer/eroski-sello-03.png';
import eroskifooterarrow2 from '../assets/images/footer/eroski-footer2-arrow.png';
import { useAppStore } from '../store/AppContext';
import { AccessType } from '../types/Types';
import FooterMenuLink from './bricks/FooterMenuLink';
import { FooterConstants } from '../utils/FooterConstants';

interface Props {
  eventClickBarOptions: any;
  eventClickScrollLeft: any;
  eventClickAcordion: any;
  footerLink: AccessType[];
  getUrlLink: any;
}

const FooterEroski: FC<Props> = (props) => {
  const { t } = useTranslation();
  const dataApp = useAppStore();
  const {
    eventClickBarOptions,
    eventClickScrollLeft,
    eventClickAcordion,
    footerLink,
    getUrlLink,
  } = props;

  return (
    <footer>
      <div id="f2" className="f2 f2-cast">
        <div className="f2-quicklinks__arrows">
          {/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid,jsx-a11y/control-has-associated-label */}
          <a href="#" id="right-button" className="mobile-only" />
          {/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid,jsx-a11y/control-has-associated-label */}
          <a
            href="#"
            id="left-button"
            className="mobile-only"
            onClick={eventClickBarOptions}
          />
        </div>
        <div className="f2-quicklinks__container">
          <ul className="f2-quicklinks">
            <QuickLink
              text={t('footer.compraOnline')}
              fromApp={`${t('web_ecommerce')}`}
              url={`${process.env.REACT_APP_SERVER_SUPER}${t('link.super')}`}
              title="Eventos"
              className="f2-quicklinks__item--6"
            >
              <ComprasOnlineSvg />
            </QuickLink>
            <QuickLink
              text={t('footer.tiendas')}
              fromApp={`${t('eroski_es')}`}
              url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
                'link.tiendas',
              )}`}
              title={t('footer.tiendas')}
              className="f2-quicklinks__item--5"
            >
              <TiendasSvg />
            </QuickLink>
            <QuickLink
              text={t('footer.vales')}
              fromApp={`${t('eroski_es')}`}
              // url={routerLoader.LoadRouterByPath('vales', dataApp.lang)}
              url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
                'link.vales-ahorro',
              )}`}
              title={t('footer.vales')}
              className="f2-quicklinks__item--4"
            >
              <ValesSvg />
            </QuickLink>
            <QuickLink
              text={t('footer.contacto')}
              fromApp={`${t('eroski_es')}`}
              url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
                'link.contacto',
              )}`}
              title={t('footer.contacto')}
              className="f2-quicklinks__item--3"
            >
              <ContactoSvg />
            </QuickLink>
            <QuickLink
              text={t('footer.folletos')}
              fromApp={`${t('eroski_es')}`}
              url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t(
                'link.folletos',
              )}`}
              title={t('footer.folletos')}
              className="f2-quicklinks__item--2"
            >
              <FolletosSvg />
            </QuickLink>
            <QuickLink
              text={t('footer.eroskiClub')}
              fromApp={`${t('eroski_es')}`}
              url={`${process.env.REACT_APP_SERVER_EROSKI_ES}${t('link.club')}`}
              title={t('footer.eroskiClub')}
              className="f2-quicklinks__item--3"
            >
              <ClubSvg />
            </QuickLink>
          </ul>

          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className="f2-quicklinks__arrow-container"
            onClick={eventClickScrollLeft}
          >
            <img
              className="f2-quicklinks__arrow-container--image"
              src={eroskifooterarrow2}
              alt="footer arrow"
            />
          </div>
        </div>

        <div className="f2-info__container">
          <ul className="f2-info">
            <li className="f2-info__item f2-info__item--1">
              <a
                href={`${
                  process.env.REACT_APP_API
                }/clienteLogado/getTK?fromUrl=${
                  process.env.REACT_APP_SERVER_EROSKI_ES
                }${t('link.eroskies')}&fromApp=${t('eroski_es')}`}
              >
                <LogoSvg />
              </a>
            </li>

            <li className="f2-info__item f2-info__item--2">
              <span className="desktop-only social-links">
                {t('footer.siguenos')}
              </span>
              <ul>
                <li className="fb">
                  <a href={`${FooterConstants.URL_FACEBOOK_EROSKI}`}>
                    <Face />
                  </a>
                </li>
                <li className="tw">
                  <a href={`${FooterConstants.URL_TWITTER_EROSKI}`}>
                    <Twitter />
                  </a>
                </li>
                <li className="yt">
                  <a href={`${FooterConstants.URL_YOUTUBE_EROSKI}`}>
                    <Youtube />
                  </a>
                </li>
                <li className="ig">
                  <a href={`${FooterConstants.URL_INSTAGRAM_EROSKI}`}>
                    <Insta />
                  </a>
                </li>
                <li className="pt">
                  <a href={`${FooterConstants.URL_PINTEREST_EROSKI}`}>
                    <Pinterest />
                  </a>
                </li>
                <li className="ti">
                  <a href={`${FooterConstants.URL_TIKTOK_EROSKI}`}>
                    <Tiktok />
                  </a>
                </li>
                <li className="li">
                  <a href={`${FooterConstants.URL_LINKEDIN_EROSKI}`}>
                    <Linkedin />
                  </a>
                </li>
              </ul>
            </li>
            <li className="f2-info__item f2-info__item--3">
              <p
                className="desktop-only"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: t('footer.cc') }}
              />
              <p className="mobile-only">
                <strong>
                  <a href="tel:944943444">{`${FooterConstants.TELEFONO_ATENCION_CLIENTE}`}</a>
                </strong>
                <br />
                {t('footer.ccMovil')}
              </p>
            </li>
          </ul>
        </div>

        <div className="f2-links__container">
          <div className="f2-links">
            <ul className="f2-links1">
              <li className="f2-links1__item f2-links__item--1">
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span onClick={eventClickAcordion}>{t('footer.eroski')}</span>
                <ul>
                  <li>
                    <a
                      href={`${FooterConstants.URL_CORPORATIVO}${t(
                        'link.quienes-somos',
                      )}`}
                    >
                      {t('footer.quienesSomos')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${FooterConstants.URL_CORPORATIVO}${t(
                        'link.rsc',
                      )}`}
                    >
                      {t('footer.rsc')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${FooterConstants.URL_CORPORATIVO}${t(
                        'link.fundacion-eroski',
                      )}`}
                    >
                      {t('footer.fundacionEroski')}
                    </a>
                  </li>
                  <li>
                    <a href={`${FooterConstants.URL_MEMORIA}${dataApp?.lang}`}>
                      {t('footer.memoria')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.sostenibilidad')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.sostenibilidad')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${FooterConstants.URL_CORPORATIVO}${t(
                        'link.inversores',
                      )}`}
                    >
                      {t('footer.inversores')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${FooterConstants.URL_CORPORATIVO}${t(
                        'link.gobierno-corporativo',
                      )}`}
                    >
                      {t('footer.gobierno')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.inmobiliaria')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.inmobiliaria')}
                    </a>
                  </li>
                  <li>
                    <a href={`${FooterConstants.URL_SALA_DE_PRENSA}`}>
                      {' '}
                      {t('footer.salaPrensa')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.trabaja-con-nosotros')}&fromApp=${t(
                        'eroski_es',
                      )}`}
                    >
                      {t('footer.trabajaAki')}
                    </a>
                  </li>
                </ul>
              </li>
              <li className="f2-links1__item f2-links__item--2">
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span onClick={eventClickAcordion}>{t('footer.ccTitle')}</span>
                <ul>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.contacto')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.formularioContacto')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.tiendaOnline')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.tiendaOnline')}
                    </a>
                  </li>
                </ul>
              </li>
              <li className="f2-links1__item f2-links__item--3">
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span onClick={eventClickAcordion}>
                  {t('footer.tiendaEroski')}
                </span>
                <ul>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.tiendas')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.buscadorTiendas')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.festivos')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.festivos')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_SUPER
                      }${t('link.super')}&fromApp=${t('web_ecommerce')}`}
                    >
                      {t('footer.superMercado')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        FooterConstants.URL_DESCANSO_INICIO
                      }${dataApp.lang}${
                        FooterConstants.URL_DESCANSO_FINAL
                      }&fromApp=${t('descanso')}`}
                    >
                      {t('footer.descanso')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        FooterConstants.URL_ELECTROHOGAR
                      }${dataApp.lang}/&fromApp=${t('tecno_electro')}`}
                    >
                      {t('footer.electro')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${FooterConstants.URL_SEGUROS_INICIO}${dataApp.lang}${FooterConstants.URL_SEGUROS_FINAL}`}
                    >
                      {t('footer.seguros')}
                    </a>
                  </li>
                  <li>
                    <a href={`${FooterConstants.URL_VIAJES}`}>
                      {t('footer.viajes')}
                    </a>
                  </li>
                </ul>
              </li>

              <li className="f2-links1__item f2-links__item--4">
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span onClick={eventClickAcordion}>
                  {t('footer.servicios')}
                </span>
                <ul>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.financiacion')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.financiacion')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.tarjeta-credito-eroski')}&fromApp=${t(
                        'eroski_es',
                      )}`}
                    >
                      {t('footer.tarjetaEroskiClub')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.encargos')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.encargos')}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${
                        process.env.REACT_APP_API
                      }/clienteLogado/getTK?fromUrl=${
                        process.env.REACT_APP_SERVER_EROSKI_ES
                      }${t('link.eventos')}&fromApp=${t('eroski_es')}`}
                    >
                      {t('footer.eventos')}
                    </a>
                  </li>
                </ul>
              </li>
              <li className="f2-links1__item f2-links__item--5">
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span onClick={eventClickAcordion}>
                  {t('footer.areaCliente')}
                </span>
                <ul>
                  {footerLink &&
                    footerLink.map((acc: AccessType) => (
                      <FooterMenuLink
                        text={acc.descripcion}
                        url={getUrlLink(acc)}
                        key={acc.url}
                        openInNewWindow={acc.openInNewWindow}
                      />
                    ))}
                </ul>
              </li>
            </ul>

            <ul className="f2-links2">
              <li className="f2-links2__item f2-links2__item--1">
                <span>{t('footer.formaPago')}</span>
                <ul>
                  <li>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      <Payment />
                    </a>
                  </li>
                </ul>
              </li>
              <li className="f2-links2__item f2-links2__item--2">
                <span>{t('footer.seguridadConfianza')}</span>
                <ul>
                  <li>
                    <a href={`${FooterConstants.URL_CONFIANZA}`}>
                      <Trust />
                    </a>
                  </li>
                  <li>
                    <a href={`${FooterConstants.URL_ADIGITAL}`}>
                      <Digital />
                    </a>
                  </li>
                </ul>
              </li>
              <li className="f2-links2__item f2-links2__item--3">
                <span>{t('footer.premio')}</span>
                <ul>
                  <li>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      <img
                        src={eroskisello03}
                        alt=""
                        className="f2-links2__icon"
                      />
                    </a>
                  </li>
                </ul>
              </li>
              <li className="f2-links2__item f2-links2__item--4 app">
                <span>{t('footer.descarga')}</span>
                <ul>
                  <li className="googleplay">
                    <a href={`${FooterConstants.URL_GOOGLE_PLAY}`}>
                      <Android2 />
                    </a>
                  </li>
                  <li className="appstore">
                    <a href={`${FooterConstants.URL_APP_STORE}`}>
                      <Ios2 />
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div className="f2-legalLinks__container">
          <ul className="f2-legalLinks">
            <li className="f2-legalLinks__item legals">
              <ul>
                <li>
                  <a
                    href={`${
                      process.env.REACT_APP_API
                    }/clienteLogado/getTK?fromUrl=${
                      process.env.REACT_APP_SERVER_EROSKI_ES
                    }${t('link.condiciones-club')}&fromApp=${t('eroski_es')}`}
                  >
                    {t('footer.condicionesClub')}
                  </a>
                </li>
                <li>
                  <a
                    href={`${
                      process.env.REACT_APP_API
                    }/clienteLogado/getTK?fromUrl=${
                      process.env.REACT_APP_SERVER_EROSKI_ES
                    }${t('link.condiciones-oro')}&fromApp=${t('eroski_es')}`}
                  >
                    {t('footer.condicionesTarjeta')}
                  </a>
                </li>
                <li>
                  <a
                    href={`${
                      process.env.REACT_APP_API
                    }/clienteLogado/getTK?fromUrl=${
                      process.env.REACT_APP_SERVER_EROSKI_ES
                    }${t('link.terminos')}&fromApp=${t('eroski_es')}`}
                  >
                    {t('footer.teminosCondiciones')}
                  </a>
                </li>
                <li>
                  <a
                    href={`${
                      process.env.REACT_APP_API
                    }/clienteLogado/getTK?fromUrl=${
                      process.env.REACT_APP_SERVER_EROSKI_ES
                    }${t('link.cookies')}&fromApp=${t('eroski_es')}`}
                  >
                    {t('footer.politicas')}
                  </a>
                </li>
                <li>
                  <a
                    href={`${
                      process.env.REACT_APP_API
                    }/clienteLogado/getTK?fromUrl=${
                      process.env.REACT_APP_SERVER_EROSKI_ES
                    }${t('link.privacidad')}&fromApp=${t('eroski_es')}`}
                  >
                    {t('footer.politicasProteccionDatos')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default FooterEroski;
